import { gql } from '@apollo/client';

export const fetchEndCustomerContactsPPC = gql`
  query fetchEndCustomerContactsPPC($id: String, $transactionAccountId: String, $isRestricted: Boolean) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      endCustomerContacts(isRestricted: $isRestricted) {
        accountId
        email
        name
        picture
      }
    }
  }
`;
